/*
    Copyright (c) Computer-L.A.N. GmbH (http://www.computer-lan.de).
    Alle Rechte vorbehalten.
*/

import AnyUtil from "../../Basis/Utils/AnyUtil";
import StringUtil from "../../Basis/Utils/StringUtil";
import { fixedT, translationKeys } from "./../Internationalisierung/i18nBasis";

export default class Pflichtangabe {
    public static get regelName(): string {
        return "Pflichtangabe";
    }

    public validate(wert: any): string {
        if (AnyUtil.isNullOrUndefined(wert) || (typeof wert === "string" && StringUtil.isEmpty(wert))) {
            return fixedT(translationKeys.pflichtangabe.pflichtangabe);
        }

        return "";
    }
}
